import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiDialogContent(_theme: Theme): MuiThemeComponentOverride<"MuiDialogContent"> {
  return {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "32px 16px",
        },
      },
    },
  };
}
